<div class="registration-form">
  <form class="loginform">
    <!-- <div class="form-icon"> -->
    <img class="icon icon-user" src="assets/images/recycle.png">
    <!-- </div> -->
    <div class="header">
      <p class="text-title">{{publicservice.Texts.Texts['login1']}}</p>
      <p class="text-break">{{publicservice.Texts.Texts['login2']}}</p>
    </div>
    <!-- <mat-label for="usr"> :لطفا شماره موبایل خود را وارد کنید</mat-label> -->

    <div dir="ltr">
      <mat-form-field class="form-group" appearance="outline">
        <!-- <mat-label class="enterText"> :لطفا شماره موبایل خود را وارد کنید</mat-label><br> -->
        <!-- <mat-label class="label">{{publicservice.Texts.Texts["login3"]}}
        </mat-label> -->
        <input matInput [formControl]="phonenumberlogin" class="item" id="phone-number"
               [(ngModel)]="publicservice.PhoneNumber"
               placeholder="09123456789 مثلا" pattern="[0-9]*" type="tel">
        <mat-error *ngIf="phonenumberlogin.hasError('pattern') && !phonenumberlogin.hasError('required')"
                   class="error">
          <p class="text-break">{{publicservice.Texts.Texts["login4"]}}</p>
        </mat-error>
        <mat-error *ngIf="phonenumberlogin.hasError('required')" class="error">
          {{publicservice.Texts.Texts["login5"]}}
          <!-- <strong>{{publicservice.Texts.Texts["login3"]}}</strong>
          {{publicservice.Texts.Texts["logi3"]}} -->
        </mat-error>
      </mat-form-field>
    </div>
    <div class="form-group-btn">
      <button mat-button type="submit" (click)="login()"
              class="btn btn-block create-account">{{publicservice.Texts.Texts['login3']}}</button>
    </div>
  </form>
  <mat-spinner id="loading" *ngIf="loading"></mat-spinner>

  <div class="footer">
    <div style="display: flex;text-align: center;justify-content: center;">
      <p style="font-weight: bold;padding-right: 5px;"><a href="https://karinco.ir" style="color: #000;">کارین</a></p>
      <p> طراحی و پیاده سازی توسط شرکت</p>
    </div>
  </div>

</div>

<!-- <script type="text/javascript" src="https://code.jquery.com/jquery-3.2.1.min.js"></script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/jquery.mask/1.14.15/jquery.mask.min.js"></script>
    <script src="assets/js/script.js"></script>
 -->
